export const formatNumber = (
  number: number,
  useAbbreviation = false,
  precision = 1,
) => {
  if (useAbbreviation) {
    if (number >= 1000000) {
      return `${(number / 1000000).toFixed(precision)}M`;
    }
    if (number >= 1000) {
      return `${(number / 1000).toFixed(precision)}K`;
    }
  }
  return number.toLocaleString();
};
